export default "__VITE_ASSET__DRnkZRzY__"